// Shared by any widget that displays agent_checkin.model to a human
// (PeopleAndAgentsPreview, TopModelsUsed, TopProjects). Only Claude Code
// models exist in practice today, but this doesn't hardcode a "claude-"
// prefix requirement — it just drops it when present and title-cases
// whatever's left, so it won't mangle a future non-Claude model string it's
// never seen.
//
// 2026-09-09 fix: real model ids from .message.model carry a trailing
// 8-digit release-date suffix (e.g. "claude-opus-4-5-20250929"), which this
// function used to fold straight into the version string as if it were
// another version segment — "Opus 4.5.20250929" instead of "Opus 4.5". Strip
// it the same way the server-side pricing lookup (private.resolve_model_rate)
// does, so the display label and the pricing lookup agree on what the
// "version" actually is.
//
// "claude-opus-4-5-20250929" -> "Claude Opus 4.5"
const DATE_SUFFIX = /-\d{8}$/

export function normalizeModelId(model: string | null | undefined): string | null {
  if (!model) return null
  const normalized = model.trim().toLowerCase().replace(/^(anthropic[./:])/, '')
  return normalized || null
}

export function formatModelLabel(model: string | null | undefined): string {
  if (!model) return 'Unknown model'
  const parts = model.replace(DATE_SUFFIX, '').split('-').filter(Boolean)
  const hasClaudePrefix = parts[0]?.toLowerCase() === 'claude'
  if (hasClaudePrefix) parts.shift()
  if (parts.length === 0) return model

  const [name, ...versionParts] = parts
  const nameLabel = name.charAt(0).toUpperCase() + name.slice(1)
  const version = versionParts.join('.')
  const label = version ? `${nameLabel} ${version}` : nameLabel
  return hasClaudePrefix ? `Claude ${label}` : label
}

// Short form without the "Claude" brand prefix, for tight spaces (e.g. next
// to a client_name that's already "Claude Code").
export function formatModelLabelShort(model: string | null | undefined): string | null {
  if (!model) return null
  const parts = model.replace(DATE_SUFFIX, '').split('-').filter(Boolean)
  if (parts[0]?.toLowerCase() === 'claude') parts.shift()
  if (parts.length === 0) return model
  const [name, ...versionParts] = parts
  const label = name.charAt(0).toUpperCase() + name.slice(1)
  const version = versionParts.join('.')
  return version ? `${label} ${version}` : label
}
